import controller from "./controller/controller.js";

export function loader() {
	const isHomePage = window.location.pathname === '/';
	const isRuRegion = document.querySelector('.region-ru')

	if (!isHomePage) {
		return;
	}

	// if (
	// 	isHomePage &&
	// 	sessionStorage.getItem('homepagePreloaderShown')
	// ) {
	// 	return;
	// }

	if (isHomePage) {
		sessionStorage.setItem('homepagePreloaderShown', 'true');
	}

	const difSizes = {
		1023: 'tablet',
		768: 'mobile'
	};

	const windowSize = window.innerWidth;
	const breakpoints = Object.keys(difSizes)
		.map(Number)
		.sort((a, b) => a - b);

	const matchedKey = breakpoints.find(size => windowSize <= size);
	const currentDevice = matchedKey ? difSizes[matchedKey] : 'desktop';

	const loaderSrc = `/local/assets/images/logo_${currentDevice + (isRuRegion ? '-ru' : '')}.svg`;
	const loaderContainer = document.createElement('div');
	const loader = document.createElement('object');

	let logoId, svg, player;

	loader.classList.add('preloader');
	loaderContainer.classList.add('preloader-wrap');
	loader.classList.add('container');

	loader.setAttribute('type', 'image/svg+xml');
	loader.setAttribute('width', '100%');
	loader.setAttribute('id', 'preloader');

	const waitForSvg = (onReady, onFail) => {
		let attempt = 0;
		const maxAttempts = 50; // ~5 сек
		const tick = () => {
			const doc = loader.contentDocument;
			// SVG битый — прекращаем, иначе бесконечный цикл
			if (doc?.querySelector('parsererror')) {
				onFail?.();
				return;
			}
			if (playerSvg()) {
				onReady();
				return;
			}
			if (++attempt < maxAttempts) {
				setTimeout(tick, 100);
			} else {
				onFail?.();
			}
		};
		tick();
	};

	const playerSvg = () => {
		const doc = loader.contentDocument;
		const svgEl = doc?.querySelector('svg');

		if (!svgEl) return false;

		logoId = svgEl.getAttribute('id');
		svg = doc.getElementById(logoId);

		if (!svg?.svgatorPlayer) return false;

		svg.svgatorPlayer.set('speed', 1);
		player = svg.svgatorPlayer;
		return true;
	};

	const loadSvgWithRetry = (attempt = 0) => {
		loader.setAttribute('data', `${loaderSrc}?t=${Date.now()}`); // сброс кэша
		loader.onload = () => {
			if (loader.contentDocument?.querySelector('parsererror')) {
				if (attempt < 3) {
					setTimeout(() => loadSvgWithRetry(attempt + 1), 500);
				}
				return;
			}
			initSvgAnimation();
		};
	};

	const initSvgAnimation = () => {
		if (initSvgAnimation.started) return;
		initSvgAnimation.started = true;

		waitForSvg(
			() => playSvgAnimation(),
			() => {
				// SVG не загрузился — просто убираем прелоадер без анимации
				removeLoader();
			}
		);
	};

	const playSvgAnimation = (forward = true) => {
		if (!player) return;

		const targetDirection = forward ? 1 : -1;

		if (player.direction !== targetDirection) {
			player.reverse();
			return;
		}

		if (forward) {
			const checkLimit = () => {
				if (player.currentTime >= 700) {
					player.pause();
					player.seek(700);
				} else if (player.playbackState === 'playing') {
					requestAnimationFrame(checkLimit);
				}
			};

			requestAnimationFrame(checkLimit);
		}

		player.play();
	};

	const addLoader = () => {
		const mountLoader = () => {
			loaderContainer.appendChild(loader);
			document.body.append(loaderContainer);
			document.body.classList.add('preloader-show');

			loader.addEventListener('load', initSvgAnimation, { once: true });
			loader.setAttribute('data', loaderSrc);

			if (loader.contentDocument?.querySelector('svg')) {
				initSvgAnimation();
			}
		};

		if (!document.body) {
			document.addEventListener('DOMContentLoaded', mountLoader, { once: true });
		} else {
			mountLoader();
		}

		controller.lockPage();
	};

	const removeLoader = () => {
		setTimeout(() => {
			document.body.classList.remove('preloader-show');
		}, 2000);

		setTimeout(() => {
			loaderContainer.remove();
			controller.unlockPage();
		}, 2500);
	};

	addLoader();

	if (document.readyState === 'complete') {
		removeLoader();
	} else {
		window.addEventListener('load', removeLoader, { once: true });
	}
}

loader();